import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { LoginType, OauthServiceType } from '@websky/graphql';
import { useTheme } from '../../../theme';
import { initI18n } from '../../../utils';
import { icons } from './icons';
initI18n('SocialAuth');
var SocialAuth = function (_a) {
    var _b;
    var authMethods = _a.authMethods, onAuthRedirect = _a.onAuthRedirect, onRemoveAuth = _a.onRemoveAuth, socialAuthAvailability = _a.socialAuthAvailability;
    var t = useTranslation('SocialAuth').t;
    var css = useTheme('Account').SocialAuth;
    var activeAuthMethods = React.useMemo(function () {
        if (authMethods === null || authMethods === void 0 ? void 0 : authMethods.length) {
            return authMethods.filter(function (method) { return method.status; });
        }
        return [];
    }, [authMethods]);
    var availableAuthMethods = React.useMemo(function () {
        var google = false;
        var facebook = false;
        var vk = false;
        var tinkoff = false;
        if (activeAuthMethods.length) {
            activeAuthMethods.forEach(function (method) {
                switch (method.social) {
                    case LoginType.Google:
                        google = true;
                        break;
                    case LoginType.Facebook:
                        facebook = true;
                        break;
                    case LoginType.Vkontakte:
                        vk = true;
                        break;
                    case LoginType.TinkoffID:
                        tinkoff = true;
                        break;
                }
            });
        }
        return { google: google, facebook: facebook, vk: vk, tinkoff: tinkoff };
    }, [activeAuthMethods]);
    var availableCommonAuthMethods = React.useMemo(function () {
        var google = !availableAuthMethods.google && socialAuthAvailability.google;
        var facebook = !availableAuthMethods.facebook && socialAuthAvailability.facebook;
        var vk = !availableAuthMethods.vk && socialAuthAvailability.vk;
        var tinkoff = !availableAuthMethods.tinkoff && socialAuthAvailability.tinkoff;
        return { google: google, facebook: facebook, vk: vk, tinkoff: tinkoff, all: google || facebook || vk || tinkoff };
    }, [availableAuthMethods, socialAuthAvailability]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css.wrapper },
            activeAuthMethods.length > 0 && (React.createElement("div", { className: cn(css.wrapper__auth, (_b = {},
                    _b[css.wrapper__auth_offset] = availableCommonAuthMethods.all,
                    _b)) }, activeAuthMethods.map(function (item) { return (React.createElement("div", { className: css.social, key: item.id },
                React.createElement("div", { className: css.social__icon }, icons[item.social]),
                React.createElement("div", { className: css.social__info },
                    React.createElement("div", { className: css.social__user }, item.userName),
                    React.createElement("div", { className: css.social__name }, item.social)),
                React.createElement("span", { className: css.social__delete, onClick: function () { return onRemoveAuth(item.id); } }, icons.close))); }))),
            availableCommonAuthMethods.all && (React.createElement("div", { className: css.login },
                React.createElement("span", { className: css.login__title }, t('Quick login to your account')),
                React.createElement("span", { className: css.login__subtitle }, t('Connect another social media account')),
                React.createElement("div", { className: css.login__auth },
                    availableCommonAuthMethods.facebook && (React.createElement("div", { "data-type": OauthServiceType.Facebook, className: css.login__auth_icon, onClick: function () {
                            onAuthRedirect(OauthServiceType.Facebook);
                        } }, icons.Facebook)),
                    availableCommonAuthMethods.google && (React.createElement("div", { "data-type": OauthServiceType.Google, className: css.login__auth_icon, onClick: function () {
                            onAuthRedirect(OauthServiceType.Google);
                        } }, icons.Google)),
                    availableCommonAuthMethods.vk && (React.createElement("div", { "data-type": OauthServiceType.Vkontakte, className: css.login__auth_icon, onClick: function () {
                            onAuthRedirect(OauthServiceType.Vkontakte);
                        } }, icons.Vkontakte)),
                    availableCommonAuthMethods.tinkoff && (React.createElement("div", { "data-type": OauthServiceType.TinkoffID, className: css.login__auth_icon, onClick: function () {
                            onAuthRedirect(OauthServiceType.TinkoffID);
                        } }, icons.TinkoffID))))))));
};
export default SocialAuth;
